import { render } from "./LabelNumber.vue?vue&type=template&id=03aa6c99&scoped=true"
import script from "./LabelNumber.vue?vue&type=script&lang=js"
export * from "./LabelNumber.vue?vue&type=script&lang=js"

import "./LabelNumber.vue?vue&type=style&index=0&id=03aa6c99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03aa6c99"]])

export default __exports__